// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"72d808e9","239":"7a093e72","667":"61cd6bc5"}[chunkId] + ".chunk.js";
};